import { getMasterById } from "./masterLookup";
export const getDepartment = (masters, deptId) =>
  getMasterById(
    masters,
    "departments",
    deptId,
    "department_id", //  FIXED
  );

export const getCity = (masters, cityId) =>
  getMasterById(
    masters,
    "cities",
    cityId,
    "city_id", //  FIXED
  );

export const getState = (masters, stateId) =>
  getMasterById(
    masters,
    "states",
    stateId,
    "state_id", // FIXED
  );

export const getDistrict = (masters, districtId) =>
  getMasterById(masters, "districts", districtId, "district_id");

export const getLocation = (masters, locationId) =>
  getMasterById(
    masters,
    "locations",
    locationId,
    "location_id", //  FIXED
  );
export const getJobGrade = (masters, gradeId) =>
  getMasterById(
    masters,
    "job_grades", //  FIXED (NOT jobGrade)
    gradeId,
    "job_grade_id", //  FIXED
  );

export const getSkill = (masters, skillId) =>
  getMasterById(
    masters,
    "skills",
    skillId,
    "skill_id", //  FIXED
  );
export const getEmploymentType = (masters, employmentTypeId) =>
  getMasterById(
    masters,
    "employment_types", //  matches API key
    employmentTypeId,
    "employment_type_id", //  matches ID field
  );

export const getNationality = (masters, countryId) =>
  getMasterById(masters, "countries", countryId, "country_id");

export const getGender = (masters, genderId) =>
  getMasterById(masters, "genders", genderId, "gender_id");

export const getMaritalStatus = (masters, maritalStatusId) =>
  getMasterById(
    masters,
    "marital_statuses",
    maritalStatusId,
    "marital_status_id",
  );

export const getReligion = (masters, religionId) =>
  getMasterById(masters, "religions", religionId, "religion_id");

export const getReservation = (masters, reservationId) =>
  getMasterById(
    masters,
    "reservation_categories",
    reservationId,
    "category_id",
  );
export const getEducationLevel = (masters, educationLevelId) =>
  getMasterById(
    masters,
    "education_levels", //  master key
    educationLevelId,
    "education_level_id", //  id field
  );

export const getSpecialization = (masters, specializationId) =>
  getMasterById(
    masters,
    "specializations", //  master key
    specializationId,
    "specialization_id", //  id field
  );

export const getMandatoryQualification = (masters, qualificationId) =>
  getMasterById(
    masters,
    "mandatory_qualifications", //  master key
    qualificationId,
    "qualification_id", //  id field
  );
